module.exports = __webpack_public_path__ + "img/mobile-29.00294cf7.png";